import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/services/queryClient';
import Loading from '@/components/Loading';
import AppRoutes from '@/routes/AppRoutes';
import theme from '@/theme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import AlertComponent from './components/Alert/Alert';
import BannerController from './components/Banner/BannerController';
import CampaignToastController from './features/campaignMessages/CampaignToastController';
import VersionChecker from './components/VersionChecker/VersionChecker';

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={<Loading />}>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <VersionChecker>
            <AlertComponent />
            <BannerController />
            <CampaignToastController />
            <AppRoutes />
          </VersionChecker>
        </ThemeProvider>
      </BrowserRouter>
    </Suspense>
  </QueryClientProvider>
);

export default App;
